<script setup lang="ts">
import SiteEditableText from '../../SiteEditableText.vue'
import type { ReviewsBlock } from '../../types'

defineProps<{ block: ReviewsBlock }>()
</script>

<template>
  <section :id="block.settings.anchorId" class="site:bg-(--site-color-surface) site:py-16 site:@min-[40rem]:py-24">
    <div class="site-site-container">
      <div class="site:mx-auto site:max-w-3xl site:text-center">
        <SiteEditableText v-if="block.content.eyebrow" v-model="block.content.eyebrow" as="p" class="site:text-sm site:font-semibold site:text-(--site-color-primary)" />
        <SiteEditableText v-model="block.content.heading" as="h2" class="site-heading site:mt-3 site:text-3xl site:font-bold site:tracking-tight site:@min-[40rem]:text-5xl" />
        <SiteEditableText v-if="block.content.description" v-model="block.content.description" as="p" class="site:mt-5 site:text-lg site:leading-8 site:text-(--site-color-muted-text)" />
      </div>

      <div class="site:mt-10 site:grid site:gap-5 site:@min-[48rem]:grid-cols-2 site:@min-[64rem]:grid-cols-3">
        <figure
          v-for="review in block.content.items"
          :key="review.id"
          class="site:flex site:min-h-64 site:flex-col site:border site:border-(--site-color-border) site:bg-(--site-color-background) site:p-6 site:shadow-(--site-shadow-sm) site:@min-[40rem]:p-8"
          :style="{ borderRadius: 'var(--site-radius-md)' }"
        >
          <div v-if="review.rating" class="site:text-sm site:tracking-[0.18em] site:text-(--site-color-primary)">
            <span role="img" :aria-label="`${review.rating} out of 5 stars`">{{ '★'.repeat(review.rating) }}</span>
          </div>
          <SiteEditableText v-model="review.quote" as="blockquote" class="site-heading site:mt-6 site:flex-1 site:text-xl site:font-semibold site:leading-8" />
          <figcaption class="site:mt-8">
            <SiteEditableText v-model="review.author" as="p" class="site:text-sm site:font-bold" />
            <SiteEditableText v-if="review.role" v-model="review.role" as="p" class="site:mt-1 site:text-sm site:text-(--site-color-muted-text)" />
          </figcaption>
        </figure>
      </div>
    </div>
  </section>
</template>
